var Dispatcher = require('flux').Dispatcher;

// Create dispatcher instance
var AuthenticationAppDispatcher = new Dispatcher();

// Convenience method to handle dispatch requests
AuthenticationAppDispatcher.handleAction = function(action) {
    this.dispatch({
        source: 'VIEW_ACTION',
        action: action
    });
};

module.exports = AuthenticationAppDispatcher;